function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 10.3333V8C16 6.89543 15.1046 6 14 6H10C8.89543 6 8 6.89543 8 8V10.3333C8 10.7015 8.29848 11 8.66667 11C9.03486 11 9.33333 10.7015 9.33333 10.3333V8.5C9.33333 7.94772 9.78105 7.5 10.3333 7.5H13.6667C14.219 7.5 14.6667 7.94772 14.6667 8.5V10.3333C14.6667 10.7015 14.9651 11 15.3333 11C15.7015 11 16 10.7015 16 10.3333Z",
  fill: "currentColor"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 4,
  y: 11,
  width: 16,
  height: 9,
  rx: 2,
  stroke: "currentColor",
  strokeWidth: 1.5
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.74 2.28176L19.2095 1.111C19.0918 0.851218 18.9134 0.857071 18.8129 1.12401L18.0092 3.25915C17.854 3.67157 17.8941 3.76981 18.3118 3.92706L20.447 4.73076C20.7139 4.83124 20.836 4.70095 20.7183 4.44117L20.2553 3.41932C20.2321 3.38129 20.211 3.3467 20.1916 3.31481C20.2872 3.3088 20.3831 3.28853 20.4734 3.25608C20.5228 3.23834 20.573 3.22272 20.6239 3.20928C20.8669 3.1452 21.1205 3.13231 21.3686 3.17142C21.6168 3.21052 21.8542 3.30078 22.0656 3.43645C22.2771 3.57213 22.4581 3.75027 22.597 3.95958C22.736 4.16888 22.83 4.40478 22.873 4.65232C22.916 4.89986 22.9071 5.15363 22.8468 5.39754C22.7865 5.64145 22.6762 5.87018 22.5229 6.06922C22.4908 6.11094 22.4569 6.15117 22.4214 6.18981C22.1996 6.43106 22.0835 6.78686 22.2407 7.0744C22.3979 7.36194 22.7635 7.47159 23.0145 7.26098C23.18 7.12214 23.3305 6.96545 23.463 6.79339C23.7167 6.4641 23.8991 6.08569 23.9988 5.68216C24.0985 5.27862 24.1133 4.85878 24.0421 4.44924C23.971 4.03971 23.8156 3.64943 23.5856 3.30315C23.3557 2.95687 23.0563 2.66215 22.7065 2.43768C22.3566 2.21321 21.9639 2.0639 21.5533 1.9992C21.1428 1.9345 20.7232 1.95583 20.3213 2.06185C20.1199 2.11497 19.9251 2.18878 19.74 2.28176Z",
  fill: "currentColor"
});
const SvgOrganizationIcon = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrganizationIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/organization-icon.02589226.svg";
export { ForwardRef as ReactComponent };